export enum WindowTarget {
  BLANK = '_blank',
  SELF = '_self',
  TOP = '_top',
}
